// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeliveredProcedureOutlinedSvg from "@fishx/icons-svg/es/asn/DeliveredProcedureOutlined";
import FishxIcon from '../components/FishxIcon';

var DeliveredProcedureOutlined = function DeliveredProcedureOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeliveredProcedureOutlinedSvg
  }));
};

DeliveredProcedureOutlined.displayName = 'DeliveredProcedureOutlined';
export default React.forwardRef(DeliveredProcedureOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DeliveredProcedureOutlined.js
// module id = 2402
// module chunks = 0